import { DxMp_Fwd_Lnk } from 'src/app/shared/models/domain/dxmp_fwd_lnk.';
import { MJnr_Inst } from 'src/app/shared/models/domain/mjnr_inst';
import { Source } from 'src/app/shared/models/domain/source';
import { Target } from 'src/app/shared/models/domain/target';
import { Expression } from 'src/app/shared/models/domain/expression';
import { Dashboards } from 'src/app/shared/models/domain/dashboards';
import { Filter } from 'src/app/shared/models/domain/filter';
import { MJoiner } from 'src/app/shared/models/domain/mjoiner';
import { Rollup } from 'src/app/shared/models/domain/rollup';
import { TStage } from 'src/app/shared/models/domain/tstage';
import { Union } from 'src/app/shared/models/domain/union';
import { Splitter } from 'src/app/shared/models/domain/splitter';
import { ReusableDesignInst } from 'src/app/shared/models/domain/reusabledesigninst';
import { HiveTransform } from 'src/app/shared/models/domain/hivetransform';
import { Input } from 'src/app/shared/models/domain/input';
import { Output } from 'src/app/shared/models/domain/output';
import { LookUp } from 'src/app/shared/models/domain/lookup';
import { TransformWrapper } from './transform.wrapper';
import { Design } from 'src/app/shared/models/domain/design';
import { DesignWrapper } from '../design.wrapper';
import { Util } from 'src/app/shared/utils/util';
import { ObjectWrapperUtil } from 'src/app/shared/utils/object.wrapper.util';
import { DataObjectWrapper } from '../../dataobject/dataobject.wrapper';
import { SourceWrapper } from './source/source.wrapper';
import { Splt_Inst_Cnd } from 'src/app/shared/models/domain/splt_inst_cnd';
import { Dashboards_Inst_Cnd } from 'src/app/shared/models/domain/dashboards_inst_cnd';
import { MJnr_Inst_Cnd } from 'src/app/shared/models/domain/mjnr_inst_cnd';
import { Lkup_Inst_Cnd } from 'src/app/shared/models/domain/lkup_inst_cnd';
import { LAttribute } from 'src/app/shared/models/domain/lattribute';
import { TargetWrapper } from './target/target.wrapper';
import { Param } from 'src/app/shared/models/domain/param';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Lkup_Inst } from 'src/app/shared/models/domain/lkup_Inst';
import { SourceConnect } from 'src/app/shared/models/domain/sourceconnect';
import { TargetConnect } from 'src/app/shared/models/domain/targetconnect';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';
import { Transpose } from 'src/app/shared/models/domain/transpose';
import { SelectTransform } from 'src/app/shared/models/domain/selecttransform';
import { DataCleanse } from 'src/app/shared/models/domain/datacleanse';
import { DxMp_Fwd_LnkObj } from 'src/app/shared/beans/dxmp_fwd_lnkobj';
import { DataMasking } from 'src/app/shared/models/domain/datamasking';

export class TransformsUtil {
    private static instance: TransformsUtil;

    static getInstance() {
        if (!TransformsUtil.instance) {
            TransformsUtil.instance = new TransformsUtil();
        }

        return TransformsUtil.instance;
    }

    util: Util;
    objectWrapperUtil: ObjectWrapperUtil;

    /**
    * TransformsUtil is a singleton class, so use TransformsUtil.getInstance() method instead of creating new TransformsUtil().
    */
    private constructor() {
        this.util = Util.getInstance();
        this.objectWrapperUtil = ObjectWrapperUtil.getInstance();
    }

    copy(transformsTmp: Array<any>): Array<any> {
        let transforms: Array<any> = new Array<any>();

        for (let i: number = 0; i < transformsTmp.length; i++) {
            let transform: any = this.parse(transformsTmp[i]);
            if (!transform) continue;

            transforms.push(transform);
        }

        return transformsTmp;
    }

    copyFrom(transforms: Array<any>, transformsTmp: Array<any>): void {
        let transformsMap: Map<number, any> = new Map<number, any>();

        for (let i: number = 0; i < transforms.length; i++) {
            let transform: Object = transforms[i];
            transformsMap.set(this.getTransform_Id(transform), transform);
        }

        transforms.splice(0, transforms.length);

        for (let i: number = 0; i < transformsTmp.length; i++) {
            let transformTmp: Object = transformsTmp[i];
            let transform: Object = transformsMap.get(this.getTransform_Id(transformTmp));
            if (transform) {
                this.copyFromTransform(transform, transformTmp);
            } else {
                transform = this.parse(transformTmp)
            }

            transforms.push(transform);
        }
    }

    compare(transforms: Array<any>, transformsTmp: Array<any>): string {
        if (transforms.length != transformsTmp.length) {
            return "transforms length mismatch."
        }

        let transformsTmpMap: Map<Number, any> = new Map<number, any>();
        for (let i: number = 0; i < transformsTmp.length; i++) {
            transformsTmpMap.set(this.getTransform_Id(transformsTmp[i]), transformsTmp[i]);
        }

        for (let i: number = 0; i < transforms.length; i++) {
            let transform: any = transforms[i];
            let transformTmp: any = transformsTmpMap.get(this.getTransform_Id(transform));
            if (!transformTmp) {
                return "transform not found";
            }

            if (transform.compare(transformTmp) != "") {
                return "transform has changes."
            }
        }

        return "";
    }

    toString(transforms: Array<any>): string {
        return '';
    }

    getTransform_Id(transform: any): number {
        if (transform.hasOwnProperty('src_Inst')) {
            if (transform.hasOwnProperty('dataObject'))
                return (transform as Source).src_Inst.src_Inst_Id;
            else
                return (transform as SourceConnect).src_Inst.src_Inst_Id;
        }

        if (transform.hasOwnProperty('tgt_Inst')) {
            if (transform.hasOwnProperty('dataObject'))
                return (transform as Target).tgt_Inst.tgt_Inst_Id;
            else
                return (transform as TargetConnect).tgt_Inst.tgt_Inst_Id;
        }

        if (transform.hasOwnProperty('expr_Inst')) {
            return (transform as Expression).expr_Inst.expr_Inst_Id;
        }

      
        if (transform.hasOwnProperty('dataMaskingInst')) {
            return (transform as DataMasking).dataMaskingInst.dataMaskingInstId;
        }

        if (transform.hasOwnProperty('fltr_Inst')) {
            return (transform as Filter).fltr_Inst.fltr_Inst_Id;
        }

        if (transform.hasOwnProperty('mJnr_Inst')) {
            return (transform as MJoiner).mJnr_Inst.mJnr_Inst_Id;
        }

        if (transform.hasOwnProperty('rlup_Inst')) {
            return (transform as Rollup).rlup_Inst.rlup_Inst_Id;
        }

        if (transform.hasOwnProperty('select_Inst')) {
            return (transform as SelectTransform).select_Inst.select_Inst_Id;
        }

        if (transform.hasOwnProperty('datacleanse_Inst')) {
            return (transform as DataCleanse).datacleanse_Inst.datacleanse_Inst_Id;
        }

        if (transform.hasOwnProperty('tStg_Inst')) {
            return (transform as TStage).tStg_Inst.tStg_Inst_Id;
        }

        if (transform.hasOwnProperty('venn_Unon_Inst')) {
            return (transform as Union).venn_Unon_Inst.venn_Unon_Inst_Id;
        }

        if (transform.hasOwnProperty('splt_Inst')) {
            return (transform as Splitter).splt_Inst.splt_Inst_Id;
        }
        if (transform.hasOwnProperty('dashboards_Inst')) {
            return (transform as Dashboards).dashboards_Inst.dashboards_Inst_Id;
        }


        if (transform.hasOwnProperty('rDesign_Inst')) {
            return (transform as ReusableDesignInst).rDesign_Inst.rDesign_Inst_Id;
        }

        if (transform.hasOwnProperty('transform_Inst')) {
            return (transform as HiveTransform).transform_Inst.transform_Inst_Id;
        }

        if (transform.hasOwnProperty('input_Inst')) {
            return (transform as Input).input_Inst.input_Inst_Id;
        }

        if (transform.hasOwnProperty('output_Inst')) {
            return (transform as Output).output_Inst.output_Inst_Id;
        }

        if (transform.hasOwnProperty('lkup_Inst')) {
            return (transform as LookUp).lkup_Inst.lkup_Inst_Id;
        }

        if (transform.hasOwnProperty('transposeInst')) {
            return (transform as Transpose).transposeInst.transpose_inst_id;
        }

        return -1;
    }

    getTransform_Nm(transform: any): string {
        if (transform.hasOwnProperty('src_Inst')) {
            if (transform.hasOwnProperty('dataObject'))
                return (transform as Source).src_Inst.instNm;
            else
                return (transform as SourceConnect).src_Inst.instNm;
        }

        if (transform.hasOwnProperty('tgt_Inst')) {
            if (transform.hasOwnProperty('dataObject'))
                return (transform as Target).tgt_Inst.instNm;
            else
                return (transform as TargetConnect).tgt_Inst.instNm;
        }

        if (transform.hasOwnProperty('expr_Inst')) {
            return (transform as Expression).expr_Inst.nm;
        }

        if (transform.hasOwnProperty('dataMaskingInst')) {
            return (transform as DataMasking).dataMaskingInst.nm;
        }

        if (transform.hasOwnProperty('fltr_Inst')) {
            return (transform as Filter).fltr_Inst.nm;
        }

        

        if (transform.hasOwnProperty('mJnr_Inst')) {
            return (transform as MJoiner).mJnr_Inst.nm;
        }

        if (transform.hasOwnProperty('rlup_Inst')) {
            return (transform as Rollup).rlup_Inst.nm;
        }

        if (transform.hasOwnProperty('select_Inst')) {
            return (transform as SelectTransform).select_Inst.nm;
        }

        if (transform.hasOwnProperty('datacleanse_Inst')) {
            return (transform as DataCleanse).datacleanse_Inst.nm;
        }

        if (transform.hasOwnProperty('tStg_Inst')) {
            return (transform as TStage).tStg_Inst.nm;
        }

        if (transform.hasOwnProperty('venn_Unon_Inst')) {
            return (transform as Union).venn_Unon_Inst.nm;
        }

        if (transform.hasOwnProperty('splt_Inst')) {
            return (transform as Splitter).splt_Inst.nm;
        }

        if (transform.hasOwnProperty('dashboards_Inst')) {
            return (transform as Dashboards).dashboards_Inst.nm;
        }

        if (transform.hasOwnProperty('rDesign_Inst')) {
            return (transform as ReusableDesignInst).rDesign_Inst.nm;
        }

        if (transform.hasOwnProperty('transform_Inst')) {
            return (transform as HiveTransform).transform_Inst.nm;
        }

        if (transform.hasOwnProperty('input_Inst')) {
            return (transform as Input).input_Inst.nm;
        }

        if (transform.hasOwnProperty('output_Inst')) {
            return (transform as Output).output_Inst.nm;
        }

        if (transform.hasOwnProperty('lkup_Inst')) {
            return (transform as LookUp).lkup_Inst.nm;
        }

        if (transform.hasOwnProperty('transposeInst')) {
            return (transform as Transpose).transposeInst.nm;
        }

        return "";
    }

    getTransform_Cd(transform: any): string {
        if (transform.hasOwnProperty('src_Inst')) {
            if (transform.streamingFlg == 'D') return 'DOBJISC';
            return 'DOBJIS';
        }

        if (transform.hasOwnProperty('tgt_Inst')) {
            if (transform.streamingFlg == 'D') return 'DOBJITC';
            return 'DOBJIT';
        }

        if (transform.hasOwnProperty('expr_Inst')) return 'EXPR';


        if (transform.hasOwnProperty('dataMaskingInst')) return 'DMSK';
        
        if (transform.hasOwnProperty('dashboards_Inst')) return 'DASHBOARDS';

        if (transform.hasOwnProperty('fltr_Inst')) return 'FLTR';

        if (transform.hasOwnProperty('mJnr_Inst')) return 'JNR';

        if (transform.hasOwnProperty('splt_Inst')) return 'SPLT';

        if (transform.hasOwnProperty('rlup_Inst')) return 'RLUP';

        if (transform.hasOwnProperty('select_Inst')) return 'SLCT';

        if (transform.hasOwnProperty('datacleanse_Inst')) return 'CNSE';

        if (transform.hasOwnProperty('tStg_Inst')) return 'TSTG';

        if (transform.hasOwnProperty('venn_Unon_Inst')) return 'UNON';

        if (transform.hasOwnProperty('input_Inst')) return 'INPUT';

        if (transform.hasOwnProperty('transform_Inst')) return 'HTRN';

        if (transform.hasOwnProperty('output_Inst')) return 'OUTPUT';

        if (transform.hasOwnProperty('rDesign_Inst')) return 'DESRUI';

        if (transform.hasOwnProperty('lkup_Inst')) return 'LKUP';

        if (transform.hasOwnProperty('transposeInst')) return 'TNPS'

        return '';
    }

    getAttribute(attr_Id: number, transform: any): Attribute {
        // if (transform.hasOwnProperty('src_Inst')) {
        //     if (transform.hasOwnProperty('dataObject'))
        //         return (transform as Source).src_Inst.instNm;
        //     else
        //         return (transform as SourceConnect).src_Inst.instNm;
        // }

        // if (transform.hasOwnProperty('tgt_Inst')) {
        //     if (transform.hasOwnProperty('dataObject'))
        //         return (transform as Target).tgt_Inst.instNm;
        //     else
        //         return (transform as TargetConnect).tgt_Inst.instNm;
        // }

        // if (transform.hasOwnProperty('expr_Inst')) {
        //     return (transform as Expression).expr_Inst.nm;
        // }

        // if (transform.hasOwnProperty('fltr_Inst')) {
        //     return (transform as Filter).fltr_Inst.nm;
        // }

        // if (transform.hasOwnProperty('mJnr_Inst')) {
        //     return (transform as MJoiner).mJnr_Inst.nm;
        // }

        // if (transform.hasOwnProperty('rlup_Inst')) {
        //     return (transform as Rollup).rlup_Inst.nm;
        // }

        // if (transform.hasOwnProperty('tStg_Inst')) {
        //     return (transform as TStage).tStg_Inst.nm;
        // }

        // if (transform.hasOwnProperty('venn_Unon_Inst')) {
        //     return (transform as Union).venn_Unon_Inst.nm;
        // }

        // if (transform.hasOwnProperty('splt_Inst')) {
        //     return (transform as Splitter).splt_Inst.nm;
        // }

        // if (transform.hasOwnProperty('rDesign_Inst')) {
        //     return (transform as ReusableDesignInst).rDesign_Inst.nm;
        // }

        // if (transform.hasOwnProperty('transform_Inst')) {
        //     return (transform as HiveTransform).transform_Inst.nm;
        // }

        // if (transform.hasOwnProperty('input_Inst')) {
        //     return (transform as Input).input_Inst.nm;
        // }

        // if (transform.hasOwnProperty('output_Inst')) {
        //     return (transform as Output).output_Inst.nm;
        // }

        // if (transform.hasOwnProperty('lkup_Inst')) {
        //     return (transform as LookUp).lkup_Inst.nm;
        // }

        // if (transform.hasOwnProperty('transposeInst')) {
        //     return (transform as Transpose).transposeInst.nm;
        // }

        return null;
    }

    getNewTransform(transform_Id: number, transform_Cd: string): any {
        switch (transform_Cd) {
            case CommonEnums.codes.SOURCE:
                let source: Source = new Source();
                source.src_Inst.src_Inst_Id = transform_Id;
                return source;
            case CommonEnums.codes.TARGET:
                let target: Target = new Target();
                target.tgt_Inst.tgt_Inst_Id = transform_Id;
                return target;
            case CommonEnums.codes.EXPRESSION:
                let expression: Expression = new Expression();
                expression.expr_Inst.expr_Inst_Id = transform_Id;
                return expression;
            case CommonEnums.codes.MASKING:
                let masking: DataMasking = new DataMasking();
                masking.dataMaskingInst.dataMaskingInstId = transform_Id;
                return expression;
            case CommonEnums.codes.FILTER:
                let filter: Filter = new Filter();
                filter.fltr_Inst.fltr_Inst_Id = transform_Id;
                return filter;
            case CommonEnums.codes.DASHBOARDS:
                    let dashboards: Dashboards = new Dashboards();
                    dashboards.dashboards_Inst.dashboards_Inst_Id = transform_Id;
                    return dashboards;    
            case CommonEnums.codes.MJOINER:
                let mJoiner: MJoiner = new MJoiner();
                mJoiner.mJnr_Inst.mJnr_Inst_Id = transform_Id;
                return mJoiner;
            case CommonEnums.codes.ROLLUP:
                let rollUp: Rollup = new Rollup();
                rollUp.rlup_Inst.rlup_Inst_Id = transform_Id;
                return rollUp;
            case CommonEnums.codes.TSTAGE:
                let tstage: TStage = new TStage();
                tstage.tStg_Inst.tStg_Inst_Id = transform_Id;
                return tstage;
            case CommonEnums.codes.UNION:
                let union: Union = new Union();
                union.venn_Unon_Inst.venn_Unon_Inst_Id = transform_Id;
                return union;
            case CommonEnums.codes.SPLITTER:
                let splitter: Splitter = new Splitter();
                splitter.splt_Inst.splt_Inst_Id = transform_Id;
                return splitter;
            case CommonEnums.codes.DESIGNLETINST:
                let reusableDesignInst: ReusableDesignInst = new ReusableDesignInst();
                reusableDesignInst.rDesign_Inst.rDesign_Inst_Id = transform_Id;
                return reusableDesignInst;
            case CommonEnums.codes.HIVETRANSFORM:
                let hiveTransform: HiveTransform = new HiveTransform();
                hiveTransform.transform_Inst.transform_Inst_Id = transform_Id;
                return hiveTransform;
            case CommonEnums.codes.INPUT:
                let input: Input = new Input();
                input.input_Inst.input_Inst_Id = transform_Id;
                return input;
            case CommonEnums.codes.OUTPUT:
                let output: Output = new Output();
                output.output_Inst.output_Inst_Id = transform_Id;
                return output;
            case CommonEnums.codes.LOOKUP:
                let lookUp: LookUp = new LookUp();
                lookUp.lkup_Inst.lkup_Inst_Id = transform_Id;
                return lookUp;
            case CommonEnums.codes.TRANSPOSE_CODE:
                let transpose: Transpose = new Transpose();
                transpose.transposeInst.transpose_inst_id = transform_Id;
                return transpose;
        }
        return null;
    }

    copyFromTransform(transform: any, transformTmp: any): void {
        if (transform.hasOwnProperty('src_Inst')) {
            (transform as Source).copyFrom(transformTmp as Source);
            return;
        }

        if (transform.hasOwnProperty('tgt_Inst')) {
            (transform as Target).copyFrom(transformTmp as Target);
            return;
        }

        if (transform.hasOwnProperty('expr_Inst')) {
            (transform as Expression).copyFrom(transformTmp as Expression);
            return;
        }

       

        if (transform.hasOwnProperty('dataMaskingInst')) {
            (transform as DataMasking).copyFrom(transformTmp as DataMasking);
            return;
        }

        if (transform.hasOwnProperty('fltr_Inst')) {
            (transform as Filter).copyFrom(transformTmp as Filter);
            return;
        }

        if (transform.hasOwnProperty('mJnr_Inst')) {
            (transform as MJoiner).copyFrom(transformTmp as MJoiner);
            return;
        }

        if (transform.hasOwnProperty('rlup_Inst')) {
            (transform as Rollup).copyFrom(transformTmp as Rollup);
            return;
        }

        if (transform.hasOwnProperty('select_Inst')) {
            (transform as SelectTransform).copyFrom(transformTmp as SelectTransform);
            return;
        }

        if (transform.hasOwnProperty('datacleanse_Inst')) {
            (transform as DataCleanse).copyFrom(transformTmp as DataCleanse);
            return;
        }

        if (transform.hasOwnProperty('tStg_Inst')) {
            (transform as TStage).copyFrom(transformTmp as TStage);
            return;
        }

        if (transform.hasOwnProperty('venn_Unon_Inst')) {
            (transform as Union).copyFrom(transformTmp as Union);
            return;
        }

        if (transform.hasOwnProperty('splt_Inst')) {
            (transform as Splitter).copyFrom(transformTmp as Splitter);
            return;
        }
        if (transform.hasOwnProperty('dashboards_Inst')) {
            (transform as Dashboards).copyFrom(transformTmp as Dashboards);
            return;
        }

        if (transform.hasOwnProperty('rDesign_Inst')) {
            (transform as ReusableDesignInst).copyFrom(transformTmp as ReusableDesignInst);
            return;
        }

        if (transform.hasOwnProperty('transform_Inst')) {
            (transform as HiveTransform).copyFrom(transformTmp as HiveTransform);
            return;
        }

        if (transform.hasOwnProperty('input_Inst')) {
            (transform as Input).copyFrom(transformTmp as Input);
            return;
        }

        if (transform.hasOwnProperty('output_Inst')) {
            (transform as Output).copyFrom(transformTmp as Output);
            return;
        }

        if (transform.hasOwnProperty('lkup_Inst')) {
            (transform as LookUp).copyFrom(transformTmp as LookUp);
            return;
        }
        if (transform.hasOwnProperty('transposeInst')) {
            (transform as Transpose).copyFrom(transformTmp as Transpose);
            return;
        }

    }

    parse(transform: any): any {
        if (transform.hasOwnProperty('src_Inst')) {
            if (transform.hasOwnProperty('dataObject')) {
                return Source.parse(transform);
            } else {
                return SourceConnect.parse(transform);
            }
        }


        if (transform.hasOwnProperty('tgt_Inst')) {
            if (transform.hasOwnProperty('dataObject')) {
                return Target.parse(transform);
            } else {
                return TargetConnect.parse(transform);
            }
        }

        if (transform.hasOwnProperty('expr_Inst')) {
            return Expression.parse(transform);
        }

        if (transform.hasOwnProperty('dataMaskingInst')) {
            return DataMasking.parse(transform);
        }

        if (transform.hasOwnProperty('fltr_Inst')) {
            return Filter.parse(transform);
        }

        if (transform.hasOwnProperty('dashboards_Inst')) {
            return Dashboards.parse(transform);
        }

        if (transform.hasOwnProperty('mJnr_Inst')) {
            return MJoiner.parse(transform);
        }

        if (transform.hasOwnProperty('rlup_Inst')) {
            return Rollup.parse(transform);
        }

        if (transform.hasOwnProperty('select_Inst')) {
            return SelectTransform.parse(transform);
        }

        if (transform.hasOwnProperty('datacleanse_Inst')) {
            return DataCleanse.parse(transform);
        }

        if (transform.hasOwnProperty('tStg_Inst')) {
            return TStage.parse(transform);
        }

        if (transform.hasOwnProperty('venn_Unon_Inst')) {
            return Union.parse(transform);
        }

        if (transform.hasOwnProperty('splt_Inst')) {
            return Splitter.parse(transform);
        }

        if (transform.hasOwnProperty('rDesign_Inst')) {
            return ReusableDesignInst.parse(transform);
        }

        if (transform.hasOwnProperty('transform_Inst')) {
            return HiveTransform.parse(transform as HiveTransform);
        }

        if (transform.hasOwnProperty('input_Inst')) {
            return Input.parse(transform as Input);
        }

        if (transform.hasOwnProperty('output_Inst')) {
            return Output.parse(transform as Output);
        }

        if (transform.hasOwnProperty('lkup_Inst')) {
            return LookUp.parse(transform as LookUp);
        }
        if (transform.hasOwnProperty('transposeInst')) {
            return Transpose.parse(transform as Transpose);
        }
        return null;
    }

    getDxMp_Fwd_LnkByObj_Id(obj_Id, dxMp_Fwd_Lnks, isFromTstage) {
        if (isFromTstage) {
            let link = {};
            for (let i = 0; i < dxMp_Fwd_Lnks.length; i++) {
                let dxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i];
                if (dxMp_Fwd_Lnk.obj_Id == obj_Id)
                    link = dxMp_Fwd_Lnk;
            }
            return link;

        } else {
            for (let i = 0; i < dxMp_Fwd_Lnks.length; i++) {
                let dxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i];
                if (dxMp_Fwd_Lnk.obj_Id == obj_Id)
                    return dxMp_Fwd_Lnk;
            }
        }
        return null;
    }

    getDxMp_Fwd_LnksByObj_Id(obj_Id, dxMp_Fwd_Lnks, isFromTstage: boolean = false) {
        let _dxMp_Fwd_Lnks = [];

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i];
            if (dxMp_Fwd_Lnk.obj_Id == obj_Id)
                _dxMp_Fwd_Lnks.push(dxMp_Fwd_Lnk);
        }
        return _dxMp_Fwd_Lnks
    }

    getTransform(obj_Id, transforms) {
        for (let i = 0; i < transforms.length; i++) {
            let transform = transforms[i];

            if (this.getTransform_Id(transform) == obj_Id)
                return transform;
        }
        return null;
    }

    getComment(comment_Id, designCanvasComments) {
        for (let i: number = 0; i < designCanvasComments.length; i++) {
            let canvasComment = designCanvasComments[i];

            if (canvasComment.comment_Inst.comment_Inst_Id == comment_Id)
                return canvasComment;
        }
        return null;
    }

    isTransform(obj_Cd: string, checkInstancesAlso: boolean): boolean {
        switch (obj_Cd) {
            case 'EXPR':
            case 'FLTR':
            case 'HTRN':
            case 'INPUT':
            case 'JNR':
            case 'OUTPUT':
            case 'DESRUI':
            case 'RLUP':
            case 'SPLT':
            case 'TSTG':
            case 'UNON':
            case 'LKUP':
            case 'TNPS':
            case 'DASHBOARDS':
                return true;
        }

        if (checkInstancesAlso) {
            switch (obj_Cd) {
                case 'DOBJIS':
                case 'DOBJIT':
                case 'DOBJISC':
                case 'DOBJITC':
                    return true;
            }
        }

        return false;
    }

    getCarryForwardTransform_Ids(transform_Id: number, include: boolean, designWrapper: DesignWrapper): Array<number> {
        let transform_Ids: Array<number> = new Array<number>();
        if (include) transform_Ids.push(transform_Id);

        this._recursionCarryForwardTransform_Ids(transform_Id, designWrapper.design.dxMp_Fwd_Lnks, transform_Ids);

        return transform_Ids;
    }

    private _recursionCarryForwardTransform_Ids(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>, transform_Ids: Array<number>): void {
        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk: DxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i];

            if (dxMp_Fwd_Lnk.obj_Id == transform_Id) {
                transform_Ids.push(dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id);
                this._recursionCarryForwardTransform_Ids(dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id, dxMp_Fwd_Lnks, transform_Ids);
            }
        }
    }

    getPreceedingTransform_Ids(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>,
        preceedingTransform_Ids: Array<number>): void {
        preceedingTransform_Ids.push(transform_Id);

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            if (dxMp_Fwd_Lnks[i].fwd_Lnk_Obj_Id != transform_Id) continue;

            this.getPreceedingTransform_Ids(dxMp_Fwd_Lnks[i].obj_Id, dxMp_Fwd_Lnks, preceedingTransform_Ids);
        }
    }

    isDuplicateLink(fromTransform_Id, toTransform_Id, dxMp_Fwd_Lnks) {
        for (let i = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i];

            if (dxMp_Fwd_Lnk.obj_Id == fromTransform_Id &&
                dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id == toTransform_Id)
                return true;
        }
    }

    isCircularLink(fromTransform_Id, toTransform_Id, dxMp_Fwd_Lnks) {
        let preceedingTransform_Ids = [];
        this.getPreceedingTransform_Ids(fromTransform_Id, dxMp_Fwd_Lnks, preceedingTransform_Ids);
        if (preceedingTransform_Ids.indexOf(toTransform_Id) != -1) return true;

        /*preceedingTransform_Ids = [];
        getPreceedingTransform_Ids( toTransform_Id, dxMp_Fwd_Lnks, preceedingTransform_Ids );
        if( preceedingTransform_Ids.indexOf(fromTransform_Id) != -1 ) return true;*/
        return false;
    }

    toStringMJnr_Inst(mJnr_Inst: MJnr_Inst) {
        return mJnr_Inst.mJnr_Inst_Id + ", " + mJnr_Inst.dxMp_Id + ", " + mJnr_Inst.nm + ", " + mJnr_Inst.description + ", " + mJnr_Inst.jnrFltrCnd + ", " +
            mJnr_Inst.jnrFltrCndValid_Cd + ", " + mJnr_Inst.ver + ", " + mJnr_Inst.valid_Cd + ", " + mJnr_Inst.persistFlg + ", " +
            mJnr_Inst.primObjId + ", " + mJnr_Inst.updateBy + ", " + mJnr_Inst.lastUpdateBy + ", " + mJnr_Inst.updateDt;
    }

    toStringLkup_Inst(lkup_Inst: Lkup_Inst) {
        return lkup_Inst.lkup_Inst_Id + ", " + lkup_Inst.dxMp_Id + ", " + lkup_Inst.nm + ", " + lkup_Inst.description + ", " + lkup_Inst.lkupFltrCnd + ", " +
            lkup_Inst.lkupFltrCndValid_Cd + ", " + lkup_Inst.ver + ", " + lkup_Inst.valid_Cd + ", " + lkup_Inst.persistFlg + ", " +
            lkup_Inst.primObjId + ", " + lkup_Inst.updateBy + ", " + lkup_Inst.lastUpdateBy + ", " + lkup_Inst.updateDt;
    }


    nameValidate(name: string, obj_Id: number, transformWrappers: Array<TransformWrapper>): string {
        let nameUC = name.toUpperCase();

        for (let i = 0; i < transformWrappers.length; i++) {
            if (transformWrappers[i].obj_Id == obj_Id) continue;

            if (transformWrappers[i].name.toUpperCase() == nameUC) {
                return "'" + nameUC + "' name is already exists.";
            }
        }

        return "";
    }


    cleanUpDxMp_Fwd_Lnks(design: Design): void {
        let transform_Ids: Array<number> = new Array<number>();
        for (let i: number = 0; i < design.objects.length; i++) {
            transform_Ids.push(this.getTransform_Id(design.objects[i]));
        }

        for (let i = 0; i < design.dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk = design.dxMp_Fwd_Lnks[i];

            if (transform_Ids.indexOf(dxMp_Fwd_Lnk.obj_Id) == -1 ||
                transform_Ids.indexOf(dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id) == -1) {
                design.dxMp_Fwd_Lnks.splice(i, 1);
                i--;
            }
        }
    }

    recursionOrderedTransform_Ids(transform_Id: number, fwd_Lnk_Obj_IdsHMap: Map<number, any>, transform_Ids: Array<number>) {
        transform_Ids.splice(0, 0, transform_Id);

        let object = fwd_Lnk_Obj_IdsHMap.get(transform_Id);
        if (object) {
            for (let i = 0; i < object.obj_Ids.length; i++) {
                let obj_Id = object.obj_Ids[i];
                let index = transform_Ids.indexOf(obj_Id);

                if (index != -1)
                    transform_Ids.splice(index, 1);

                this.recursionOrderedTransform_Ids(obj_Id, fwd_Lnk_Obj_IdsHMap, transform_Ids)
            }
        }
    }

    getOrderedTransform_Ids(design: Design): Array<number> {
        let transform_Ids: Array<number> = new Array<number>();

        let obj_Ids: Array<number> = new Array<number>();
        let fwd_Lnk_Obj_IdsHMap: Map<number, any> = new Map<number, any>();

        for (let i: number = 0; i < design.dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk: DxMp_Fwd_Lnk = design.dxMp_Fwd_Lnks[i];

            if (obj_Ids.indexOf(dxMp_Fwd_Lnk.obj_Id) == -1)
                obj_Ids.push(dxMp_Fwd_Lnk.obj_Id);

            let object: any = fwd_Lnk_Obj_IdsHMap.get(dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id);
            if (!object) {
                object = {};
                object.fwd_Lnk_Obj_Id = dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id;
                object.obj_Ids = new Array<number>();

                fwd_Lnk_Obj_IdsHMap.set(object.fwd_Lnk_Obj_Id, object);
            }

            object.obj_Ids.push(dxMp_Fwd_Lnk.obj_Id);
        }

        for (let i: number = 0; i < design.objects.length; i++) {
            let transform_Id = this.getTransform_Id(design.objects[i]);

            if (obj_Ids.indexOf(transform_Id) == -1) {
                this.recursionOrderedTransform_Ids(transform_Id, fwd_Lnk_Obj_IdsHMap, transform_Ids);
            }
        }

        return transform_Ids;
    }

    packDownStreamObj_Ids(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>, downStreamObj_Ids: Array<number>) {
        for (let i = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i];

            if (dxMp_Fwd_Lnk.obj_Id == transform_Id) {
                downStreamObj_Ids.push(dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id);
                this.packDownStreamObj_Ids(dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id, dxMp_Fwd_Lnks, downStreamObj_Ids);
            }
        }
    }

    packUpStreamObj_Ids(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>, upStreamObj_Ids: Array<number>) {
        for (let i = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i];

            if (dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id == transform_Id) {
                upStreamObj_Ids.push(dxMp_Fwd_Lnk.obj_Id);
                this.packDownStreamObj_Ids(dxMp_Fwd_Lnk.obj_Id, dxMp_Fwd_Lnks, upStreamObj_Ids);
            }
        }
    }

    // Rename downstream..
    downStreamRename(oldName: string, newName: string, oldFullName: string, newFullName: string,
        srt_Order: number, attr_Id: number, objectWrapper: ObjectWrapper, designWrapper: DesignWrapper,
        isExploadChanged: boolean = false, isChangeName: boolean = false) {

        let downStreamObj_Ids = [];
        let oldFullNameRegexp = isExploadChanged ? new RegExp(oldFullName, 'g') : new RegExp('\\b' + oldFullName + '\\b', 'g');
        let obj_Id = -1;

        if (objectWrapper == null) {
            var name:any;
            for (let i = 0; i < designWrapper.design.sqlParams.length; i++) {
                let sqlParam = designWrapper.design.sqlParams[i];
                if (sqlParam.paramVal.indexOf(name) == -1) continue;

                sqlParam.paramVal = this.util.rename(sqlParam.paramVal, oldFullNameRegexp, newFullName);
            }

            designWrapper.doValidate();
            return;
        }

        this.packDownStreamObj_Ids(objectWrapper.obj_Id, designWrapper.design.dxMp_Fwd_Lnks, downStreamObj_Ids);
        if (isChangeName) {
            for (let i = 0; i < downStreamObj_Ids.length; i++) {
                let transformWrapperTmp = designWrapper.getTransformWrapper(downStreamObj_Ids[i]);
                if (!transformWrapperTmp) continue;

                this.applyDownStreamRename(oldName, newName, oldFullName, oldFullNameRegexp, newFullName, srt_Order, attr_Id, obj_Id, transformWrapperTmp, isExploadChanged, designWrapper);
            }
        } else {
            this.applyDownStreamRename(oldName, newName, oldFullName, oldFullNameRegexp, newFullName, srt_Order, attr_Id, obj_Id,
                objectWrapper, isExploadChanged, designWrapper);
        }

        return;
    }

    private applyDownStreamRename(oldName: string, newName: string, oldFullName: string, oldFullNameRegexp: any, newFullName: string,
        srt_Order: number, attr_Id: number, obj_Id: number, objectWrapper: ObjectWrapper,
        isExploadChanged: boolean, designWrapper: DesignWrapper) {
        if (srt_Order == -1 || srt_Order == undefined) srt_Order = 0;

        if (objectWrapper.object.hasOwnProperty('attributes')) {
            for (let i = srt_Order; i < objectWrapper.object.attributes.length; i++) {
                let attribute = objectWrapper.object.attributes[i];
                if (attribute.attrExprVal.indexOf(oldFullName) == -1) continue;

                attribute.attrExprVal = this.util.rename(attribute.attrExprVal, oldFullNameRegexp, newFullName, oldFullName);
                if (isExploadChanged) {
                    attribute.valid_Cd = "EXPLODE_CHANGED";
                }
            }

        }
        if (objectWrapper.object.hasOwnProperty('derivedAttributes')) {
            for (let j = srt_Order; j < objectWrapper.object.derivedAttributes.length; j++) {
                let derivedAttribute = objectWrapper.object.derivedAttributes[j];
                if (derivedAttribute.attrExprVal.indexOf(oldFullName) == -1) continue;

                derivedAttribute.attrExprVal = this.util.rename(derivedAttribute.attrExprVal, oldFullNameRegexp, newFullName, oldFullName);
                if (isExploadChanged) {
                    derivedAttribute.valid_Cd = "EXPLODE_CHANGED";
                }
            }
        }
        if (objectWrapper.object.hasOwnProperty('mJnr_Inst_Cnds')) { //CLN-DDS-4833

            for (let i = 0; i < designWrapper.design.dxMp_Fwd_Lnks.length; i++) {
                let dxMp_Fwd_Lnk = designWrapper.design.dxMp_Fwd_Lnks[i];

                // for (let j = 0; j < transformWrapper.joinerLinkedList.length; j++) {
                //     let joinerLinkedItem = transformWrapper.joinerLinkedList[j];
                //     if (joinerLinkedItem.label.indexOf(oldFullName) != -1) continue;

                //     if (joinerLinkedItem.value == dxMp_Fwd_Lnk.obj_Id) {
                //         if (joinerLinkedItem.label != oldName) continue;
                //         joinerLinkedItem.label = this.util.getNewName(newName, transformWrapper.subNames);
                //         break;
                //     }
                // }

            }

        }

        if (objectWrapper.object.hasOwnProperty('lkup_Inst_Cnds')) {
            for (let i = srt_Order; i < objectWrapper.object.lkup_Inst_Cnds.length; i++) {
                let lkup_Inst_Cnd = objectWrapper.object.lkup_Inst_Cnds[i];
                if (lkup_Inst_Cnd.lkupCnd.indexOf(oldFullName) == -1) continue;

                lkup_Inst_Cnd.lkupCnd = this.util.rename(lkup_Inst_Cnd.lkupCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }

        if (objectWrapper.object.hasOwnProperty('splt_Inst_Cnds')) {
            for (let i = srt_Order; i < objectWrapper.object.splt_Inst_Cnds.length; i++) {
                let splt_Inst_Cnd = objectWrapper.object.splt_Inst_Cnds[i];
                if (splt_Inst_Cnd.spltCnd.indexOf(oldFullName) == -1) continue;

                splt_Inst_Cnd.spltCnd = this.util.rename(splt_Inst_Cnd.spltCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }
        if (objectWrapper.object.hasOwnProperty('dashboards_Inst_Cnds')) {
            for (let i = srt_Order; i < objectWrapper.object.dashboards_Inst_Cnds.length; i++) {
                let dashboards_Inst_Cnd = objectWrapper.object.dashboards_Inst_Cnds[i];
                if (dashboards_Inst_Cnd.dashboardsCnd.indexOf(oldFullName) == -1) continue;

                dashboards_Inst_Cnd.dashboardsCnd = this.util.rename(dashboards_Inst_Cnd.dashboardsCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }

        if (objectWrapper.object.hasOwnProperty('mJnr_Inst_Cnds')) {
            for (let i = srt_Order; i < objectWrapper.object.mJnr_Inst_Cnds.length; i++) {
                let mJnr_Inst_Cnd = objectWrapper.object.mJnr_Inst_Cnds[i];
                if (mJnr_Inst_Cnd.jnrCnd.indexOf(oldFullName) == -1) continue;

                mJnr_Inst_Cnd.jnrCnd = this.util.rename(mJnr_Inst_Cnd.jnrCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }

        if (objectWrapper.object.hasOwnProperty('src_Inst')) {
            if (objectWrapper.object.src_Inst.srcFltrCnd.indexOf(oldFullName) != -1) {
                objectWrapper.object.src_Inst.srcFltrCnd = this.util.rename(objectWrapper.object.src_Inst.srcFltrCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }

        if (objectWrapper.hasOwnProperty('mJnr_Inst')) {
            if (objectWrapper.object.mJnr_Inst.jnrFltrCnd.indexOf(oldFullName) != -1) {
                objectWrapper.object.mJnr_Inst.jnrFltrCnd = this.util.rename(objectWrapper.object.mJnr_Inst.jnrFltrCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }

        if (objectWrapper.object.hasOwnProperty('lkup_Inst')) {
            if (objectWrapper.object.lkup_Inst.lkupFltrCnd.indexOf(oldFullName) != -1) {
                objectWrapper.object.lkup_Inst.lkupFltrCnd = this.util.rename(objectWrapper.object.lkup_Inst.lkupFltrCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }

        if (objectWrapper.object.hasOwnProperty('fltr_Inst')) {
            if (objectWrapper.object.fltr_Inst.fltrCnd.indexOf(oldFullName) != -1) {
                objectWrapper.object.fltr_Inst.fltrCnd = this.util.rename(objectWrapper.object.fltr_Inst.fltrCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }

        if (objectWrapper.object.hasOwnProperty('dashboards_Inst')) {
            if (objectWrapper.object.dashboards_Inst.fltrCnd.indexOf(oldFullName) != -1) {
                objectWrapper.object.dashboards_Inst.fltrCnd = this.util.rename(objectWrapper.object.dashboards_Inst.dashboardsCnd, oldFullNameRegexp, newFullName, oldFullName);
            }
        }

        if (attr_Id != -1 && objectWrapper.object.hasOwnProperty('lAttributes')) {
            for (let i = srt_Order; i < objectWrapper.object.lAttributes.length; i++) {
                let lAttribute = objectWrapper.object.lAttributes[i];

                if (lAttribute.lnk_Obj_Inst_Id == obj_Id &&
                    lAttribute.lnk_Attr_Id == attr_Id) {
                    if (lAttribute.lAttrNm != oldName) continue;

                    lAttribute.lAttrNm = this.util.getNewName(newName, objectWrapper.subNames);

                    let fullOldName = objectWrapper.name + '.' + oldName;
                    let fullNewName = objectWrapper.name + '.' + lAttribute.lAttrNm;

                    this.downStreamRename(oldName, lAttribute.lAttrNm, fullOldName, fullNewName, -1, lAttribute.lAttr_Id, objectWrapper, objectWrapper.designWrapper);
                    break;
                }
            }
        }

        if (objectWrapper.object.hasOwnProperty('vennGroups')) {//CLN-DDS-4833
            let found = false;

            for (let i = 0; i < designWrapper.design.dxMp_Fwd_Lnks.length; i++) {
                let dxMp_Fwd_Lnk = designWrapper.design.dxMp_Fwd_Lnks[i];
                found = false;
                for (let j = srt_Order; j < objectWrapper.object.vennGroups.length; j++) {
                    let vennGroup = objectWrapper.object.vennGroups[j].venn_Grp;

                    if (vennGroup.venn_Grp_Id == dxMp_Fwd_Lnk.fwd_Lnk_Grp_Id) {
                        if (vennGroup.grpNm != oldName) continue;
                        vennGroup.grpNm = this.util.getNewName(newName, objectWrapper.subNames);
                        found = true;
                        break;
                    }

                }

                if (found) continue;

            }

        }

        objectWrapper.doValidate();
    }

    private downStreamObj_Ids: Array<number>;
    downStreamInvalidate(name: string, srt_Order: number, attr_Id: number, isDeleted: boolean, transformWrapper: TransformWrapper,
        designWrapper: DesignWrapper, dxMp_Fwd_Lnk: DxMp_Fwd_Lnk = null, isParamDbChanged: boolean = false, prevTransObj_Ids: Array<number> = new Array<number>()) {

        this.downStreamObj_Ids = [];
        let obj_Id = -1;

        if (transformWrapper == undefined) {
            //downStreamObj_Ids = getOrderedTransform_Ids( designWrapper.design );

            srt_Order = -1;
            //downStreamInvalidateOtherObjects( name, srt_Order, attr_Id, obj_Id, isDeleted, transformWrapper, designWrapper, dxMp_Fwd_Lnk, isParamDbChanged, prevTransObj_Ids );
            this.downStreamInvalidateDesign(name, srt_Order, attr_Id, isDeleted, transformWrapper, designWrapper, dxMp_Fwd_Lnk, isParamDbChanged, prevTransObj_Ids);
            return;
        }

        if (dxMp_Fwd_Lnk == undefined) {
            obj_Id = transformWrapper.obj_Id;
            //packDownStreamObj_Ids( obj_Id, designWrapper.dxMp_Fwd_Lnks, downStreamObj_Ids );

            this.applyDownStreamInvalidate(name, srt_Order, attr_Id, obj_Id, isDeleted, transformWrapper);

            srt_Order = -1;
            //downStreamInvalidateOtherObjects( name, srt_Order, attr_Id, obj_Id, isDeleted, transformWrapper, designWrapper, dxMp_Fwd_Lnk, isParamDbChanged, prevTransObj_Ids );
            this.downStreamInvalidateDesign(name, srt_Order, attr_Id, isDeleted, transformWrapper, designWrapper, dxMp_Fwd_Lnk, isParamDbChanged, prevTransObj_Ids);

            return;
        }

        /*obj_Id = dxMp_Fwd_Lnk.obj_Id;
        downStreamObj_Ids.push(dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id);
        packDownStreamObj_Ids( dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id, designWrapper.dxMp_Fwd_Lnks, downStreamObj_Ids );
    	
        if( dxMp_Fwd_Lnk.obj_Id = transformWrapper.obj_Id ) {
            downStreamInvalidateOtherObjects( transformWrapper.name, srt_Order, attr_Id, obj_Id, isDeleted, transformWrapper, designWrapper, dxMp_Fwd_Lnk, isParamDbChanged, prevTransObj_Ids );
        }
    	
        let upStreamObj_Ids = [];
        packUpStreamObj_Ids( dxMp_Fwd_Lnk.obj_Id, designWrapper.dxMp_Fwd_Lnks, upStreamObj_Ids );
    	
        srt_Order = -1;
        for( let i = 0; i < upStreamObj_Ids.length; i++ ) {
            let transformWrapperTmp = designWrapper.getTransformWrapper( upStreamObj_Ids[i] );
            if( !transformWrapperTmp ) continue;
        	
            downStreamInvalidateOtherObjects( transformWrapperTmp.name, srt_Order, attr_Id, obj_Id, isDeleted, transformWrapper, designWrapper, dxMp_Fwd_Lnk, isParamDbChanged, prevTransObj_Ids );
        }*/
    }

    private downStreamInvalidateDesign(name: string, srt_Order: number, attr_Id: number, isDeleted: boolean,
        transformWrapper: TransformWrapper, designWrapper: DesignWrapper, dxMp_Fwd_Lnk: DxMp_Fwd_Lnk,
        isParamDbChanged: boolean, prevTransObj_Ids: Array<number>) {
        let valid_Cd: string = '0';
        if (isDeleted) {
            valid_Cd = "PARAM_DEL"
        } else if (isParamDbChanged) {
            valid_Cd = "INV_RETURN_TYP"
        }

        for (let i: number = 0; i < designWrapper.design.sqlParams.length; i++) {
            let sqlParam: Param = designWrapper.design.sqlParams[i];
            if (sqlParam.paramVal.indexOf(name) == -1) continue;

            sqlParam.valid_Cd = valid_Cd;
        }

        designWrapper.doValidate();
    }

    private downStreamInvalidateOtherObjects(name: string, srt_Order: number, attr_Id: number, obj_Id: number,
        isDeleted: boolean, transformWrapper: TransformWrapper, designWrapper: DesignWrapper,
        dxMp_Fwd_Lnk: DxMp_Fwd_Lnk, isParamDbChanged: boolean, prevTransObj_Ids: Array<number>) {
        for (let i = 0; i < this.downStreamObj_Ids.length; i++) {
            let transformWrapperTmp = designWrapper.getTransformWrapper(this.downStreamObj_Ids[i]);
            if (!transformWrapperTmp) continue;

            if (!transformWrapperTmp.carryForwardAttributeObjectsHMapIds)
                transformWrapperTmp.designWrapper.setCarryForwardAttributes(transformWrapperTmp);

            this.applyDownStreamInvalidate(name, srt_Order, attr_Id, obj_Id, isDeleted, transformWrapperTmp, isParamDbChanged, prevTransObj_Ids);
        }
    }

    private applyDownStreamInvalidate(name: string, srt_Order: number, attr_Id: number, obj_Id: number, isDeleted: boolean,
        transformWrapper: TransformWrapper, isParamDbChanged: boolean = false, prevTransObj_Ids: Array<number> = new Array<number>()) {
        if (srt_Order == -1 || srt_Order == undefined) srt_Order = 0;

        let valid_Cd: string = '0';
        if (isDeleted) {
            valid_Cd = "ITEM_DEL"
        } else if (isParamDbChanged) {
            valid_Cd = "INV_RETURN_TYP"
        }

        if (transformWrapper.object.hasOwnProperty('attributes')) {
            for (let i = srt_Order; i < transformWrapper.object.attributes.length; i++) {
                let attribute: Attribute = transformWrapper.object.attributes[i];
                if (attribute.attrExprVal.indexOf(name) == -1) continue;

                attribute.valid_Cd = valid_Cd;
                attribute.error_Msg = this.objectWrapperUtil.getError_Msg(attribute.valid_Cd);
            }
        }

        if (transformWrapper.object.hasOwnProperty('mJnr_Inst_Cnds')) {
            for (let i = srt_Order; i < transformWrapper.object.mJnr_Inst_Cnds.length; i++) {
                let mJnr_Inst_Cnd: MJnr_Inst_Cnd = transformWrapper.object.mJnr_Inst_Cnds[i];
                if (mJnr_Inst_Cnd.jnrCnd.indexOf(name) == -1) continue;

                mJnr_Inst_Cnd.valid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('lkup_Inst_Cnds')) {
            for (let i = srt_Order; i < transformWrapper.object.lkup_Inst_Cnds.length; i++) {
                let lkup_Inst_Cnd: Lkup_Inst_Cnd = transformWrapper.object.lkup_Inst_Cnds[i];
                if (lkup_Inst_Cnd.lkupCnd.indexOf(name) == -1) continue;

                lkup_Inst_Cnd.valid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('splt_Inst_Cnds')) {
            for (let i = srt_Order; i < transformWrapper.object.splt_Inst_Cnds.length; i++) {
                let splt_Inst_Cnd: Splt_Inst_Cnd = transformWrapper.object.splt_Inst_Cnds[i];
                if (splt_Inst_Cnd.spltCnd.indexOf(name) == -1) continue;

                splt_Inst_Cnd.valid_Cd = valid_Cd;
            }
        }
        if (transformWrapper.object.hasOwnProperty('dashboards_Inst_Cnds')) {
            for (let i = srt_Order; i < transformWrapper.object.dashboards_Inst_Cnds.length; i++) {
                let dashboards_Inst_Cnd: Dashboards_Inst_Cnd = transformWrapper.object.dashboards_Inst_Cnds[i];
                if (dashboards_Inst_Cnd.dashboardsCnd.indexOf(name) == -1) continue;

                dashboards_Inst_Cnd.valid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('src_Inst')) {
            if (transformWrapper.object.src_Inst.srcFltrCnd.indexOf(name) != -1) {
                transformWrapper.object.src_Inst.srcFltrCndValid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('mJnr_Inst')) {
            if (transformWrapper.object.mJnr_Inst.jnrFltrCnd.indexOf(name) != -1) {
                transformWrapper.object.mJnr_Inst.jnrFltrCndValid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('fltr_Inst')) {
            if (transformWrapper.object.fltr_Inst.fltrCnd.indexOf(name) != -1) {
                transformWrapper.object.fltr_Inst.fltrCndValid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('dashboards_Inst')) {
            if (transformWrapper.object.dashboards_Inst.dashboardsCnd.indexOf(name) != -1) {
                transformWrapper.object.dashboards_Inst.dashboardsCndValid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('rlup_Inst')) {
            if (transformWrapper.object.rollup.rlup_Inst.havingClause.indexOf(name) != -1) {
                transformWrapper.object.rollup.rlup_Inst.havingClauseValid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('lkup_Inst')) {
            if (transformWrapper.object.lkup_Inst.lkupFltrCnd.indexOf(name) != -1) {
                transformWrapper.object.lkup_Inst.lkupFltrCndValid_Cd = valid_Cd;
            }
        }

        if (transformWrapper.object.hasOwnProperty('lAttributes')) {

            if (prevTransObj_Ids) {
                for (let i = srt_Order; i < transformWrapper.object.lAttributes.length; i++) {
                    let lAttribute: LAttribute = transformWrapper.object.lAttributes[i];
                    if (prevTransObj_Ids.indexOf(lAttribute.lnk_Obj_Inst_Id) == -1) continue;

                    lAttribute.lnk_Obj_Inst_Id = -1;
                    lAttribute.lnk_Attr_Id = -1;
                    lAttribute.valid_Cd = 'NO_LNK';

                    let fullName = transformWrapper.name + '.' + lAttribute.lAttrNm;
                    this.downStreamInvalidate(fullName, -1, lAttribute.lAttr_Id, false, transformWrapper, transformWrapper.designWrapper);
                }
            }

            if (isDeleted) {
                if (attr_Id == -1) {
                    /*for( let i = srt_Order; i < transformWrapper.lAttributes.length; i++ ) {
                        let lAttribute = transformWrapper.lAttributes[i];
                        if( lAttribute.lnk_Obj_Inst_Id != obj_Id ) continue;
                    	
                        lAttribute.lnk_Obj_Inst_Id = -1;
                        lAttribute.lnk_Attr_Id = -1;
                        lAttribute.valid_Cd = 'NO_LNK';
                    	
                        let fullName = transformWrapper.name + '.' + lAttribute.lAttrNm;
                        downStreamInvalidate( fullName, -1, lAttribute.lAttr_Id, false, transformWrapper, transformWrapper.designWrapper );
                    }*/
                } else {
                    for (let i = srt_Order; i < transformWrapper.object.lAttributes.length; i++) {
                        let lAttribute: LAttribute = transformWrapper.object.lAttributes[i];
                        if (lAttribute.lnk_Obj_Inst_Id != obj_Id) continue;
                        if (lAttribute.lnk_Attr_Id != attr_Id) continue;

                        lAttribute.lnk_Obj_Inst_Id = -1;
                        lAttribute.lnk_Attr_Id = -1;
                        lAttribute.valid_Cd = 'NO_LNK';

                        let fullName = transformWrapper.name + '.' + lAttribute.lAttrNm;
                        this.downStreamInvalidate(fullName, -1, lAttribute.lAttr_Id, false, transformWrapper, transformWrapper.designWrapper);

                        break;
                    }
                }
            } else if (attr_Id != -1) {
                for (let i = srt_Order; i < transformWrapper.object.lAttributes.length; i++) {
                    let lAttribute = transformWrapper.object.lAttributes[i];

                    if (lAttribute.lnk_Obj_Inst_Id != obj_Id) continue;
                    if (lAttribute.lnk_Attr_Id != attr_Id) continue;

                    let fullName = transformWrapper.name + '.' + lAttribute.lAttrNm;
                    this.downStreamInvalidate(fullName, -1, lAttribute.lAttr_Id, false, transformWrapper, transformWrapper.designWrapper);
                    break;
                }
            }
        }

        if (transformWrapper.object.hasOwnProperty('tgt_Inst')) {

            // if (transformWrapper.databaseWrapper.showDistAttributes) {
            //     if (transformWrapper.object.tgt_Inst.dist_Cmd.indexOf(name) != -1) {
            //         transformWrapper.object.tgt_Inst.dist_CmdValid_Cd = 'DIST_BY_INV';
            //     }
            // }

            if (prevTransObj_Ids) {
                for (let i = 0; i < transformWrapper.object.tgt_Attr_Lnks.length; i++) {
                    let tgt_Attr_Lnk = transformWrapper.object.tgt_Attr_Lnks[i];
                    if (prevTransObj_Ids.indexOf(tgt_Attr_Lnk.lnk_Obj_Id) == -1) continue;

                    tgt_Attr_Lnk.lnk_Obj_Id = -1;
                    tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;
                }
            }

            if (isDeleted) {
                if (attr_Id == -1) {
                    /*for( let i = 0; i < transformWrapper.tgt_Attr_Lnks.length; i++ ) {
                        let tgt_Attr_Lnk = transformWrapper.tgt_Attr_Lnks[i];
                    	
                        tgt_Attr_Lnk.lnk_Obj_Id = -1;
                        tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;
                    }*/
                } else {
                    for (let i = 0; i < transformWrapper.object.tgt_Attr_Lnks.length; i++) {
                        let tgt_Attr_Lnk = transformWrapper.object.tgt_Attr_Lnks[i];

                        if (tgt_Attr_Lnk.lnk_Obj_Id != obj_Id) continue;
                        if (tgt_Attr_Lnk.lnk_Obj_Attr_Id != attr_Id) continue;

                        tgt_Attr_Lnk.lnk_Obj_Id = -1;
                        tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;

                        (transformWrapper as TargetWrapper).validateTgt_Attr_Lnk(tgt_Attr_Lnk);
                    }
                }
            }

            /*if( !EmptyObjectsFactory.performanceMode ) 
                transformWrapper.designWrapper.setCarryForwardAttributes(transformWrapper); */

            /*	let attrNmObjectsHMap = [];
                for( let i = 0; i < transformWrapper.carryForwardAttributes.length; i++) {
                    let transformObject = transformWrapper.carryForwardAttributes[i];
    
                    for( let j = 0; j < transformObject.items.length; j++ ) {
                        let attributeObject = transformObject.items[j];
                        let attrNm = angular.lowercase(attributeObject.text);
                        //if( attrNmObjectsHMap[attrNm] != null ) continue;
    
                        attrNmObjectsHMap[attrNm] = attributeObject;
                    }
                }
    
                let dObjAttrNmsHMap = [];
                for( let j = 0; j < transformWrapper.dataObjectWrapper.attributes.length; j++ ) {
                    dObjAttrNmsHMap[transformWrapper.dataObjectWrapper.attributes[j].attr_Id] = transformWrapper.dataObjectWrapper.attributes[j].attrNm;
                }
    
                for( let i = 0; i < transformWrapper.tgt_Attr_Lnks.length; i++ ) {
                    let tgt_Attr_Lnk = transformWrapper.tgt_Attr_Lnks[i];
    
                    let attrNm = angular.lowercase(dObjAttrNmsHMap[tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id]);
    
                    transformWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
                	
                    let _attrObject = attrNmObjectsHMap[attrNm];
                    if( !_attrObject ) return;
                	
                    tgt_Attr_Lnk.valid_Cd = DITgt_Attr_Lnks.verifyFamily( tgt_Attr_Lnk, _attrObject, transformWrapper ) ? "0" : "-1";
                }*/

        }

        if (transformWrapper.object.hasOwnProperty('vennGroups')) {
            if (isDeleted &&
                attr_Id != -1) {
                let found = false;

                for (let i = srt_Order; i < transformWrapper.object.vennGroups.length; i++) {
                    let vennGroup = transformWrapper.object.vennGroups[i];

                    for (let j = 0; j < vennGroup.venn_Grp_Attrs.length; j++) {
                        let venn_Grp_Attr = vennGroup.venn_Grp_Attrs[j];

                        if (venn_Grp_Attr.lnk_Obj_Id != obj_Id) continue;
                        if (venn_Grp_Attr.lnk_Attr_Id != attr_Id) continue;

                        venn_Grp_Attr.lnk_Obj_Id = -1;
                        venn_Grp_Attr.lnk_Attr_Id = -1;

                        //        DIVenn_Grp_AttrsUtil.validateVenn_Grp_Attr(j, transformWrapper);

                        found = true;
                        break;
                    }

                    if (found) break;
                }
            }
        }

        // if (!EmptyObjectsFactory.performanceMode)
        //     transformWrapper.doValidate();
    }

    getAdditionalCarryForwardAttributes(srt_Order: number, objectWrapper: ObjectWrapper, attributes: Array<Attribute>): Array<any> {
        let carryForwardAttributesCopy = JSON.parse(JSON.stringify(objectWrapper.carryForwardAttributes));
        let carryForwardAttributesNamesListCopy = JSON.parse(JSON.stringify(objectWrapper.carryForwardAttributesNamesList));

        let transformObject = this.objectWrapperUtil.getTransformObject(objectWrapper);

        if (objectWrapper.obj_Cd == 'DOBJIS' &&
            carryForwardAttributesCopy.length > 0) {
            transformObject = carryForwardAttributesCopy[0];

            transformObject.name = objectWrapper.name;
            transformObject.objNm = objectWrapper.name;
            transformObject.text = objectWrapper.name;
        } else {
            carryForwardAttributesCopy.push(transformObject);
        }

        for (let j = 0; j < attributes.length; j++) {
            let attribute = attributes[j];
            if (srt_Order != -1 &&
                attribute.srt_Order >= srt_Order) break;

            let attributeObject = this.objectWrapperUtil.getAttributeObject(attribute, objectWrapper);
            transformObject.items.push(attributeObject);

            carryForwardAttributesNamesListCopy.push({ 'attrNm': attributeObject.name, 'attrDTyp_Nm': attributeObject.attrDTyp_Name });
        }

        return [carryForwardAttributesCopy, carryForwardAttributesNamesListCopy];

        //			} else {
        //				let carryFwdattrs = [];
        //				for( let j = 0; j < objectWrapper.attributes.length; j++ ) {
        //					let attribute = objectWrapper.attributes[j];
        //					if( srt_Order != -1 &&
        //						attribute.srt_Order >= srt_Order ) break;
        //					
        //					let attributeObject = DIObjectWrapperUtil.getAttributeObject( attribute, objectWrapper );
        //					carryFwdattrs.push(attributeObject);
        //				}
        //				
        //				return carryFwdattrs;
        //			}


    }

    getTransformWrappers(designWrapper: DesignWrapper, obj_Cd: string) {
        if (obj_Cd == undefined) return designWrapper.transformWrappers;

        let transformWrappers = [];
        for (let i = 0; i < designWrapper.transformWrappers.length; i++) {
            let transformWrapper = designWrapper.transformWrappers[i];
            if (transformWrapper.obj_Cd == obj_Cd) transformWrappers.push(transformWrapper);
        }

        return transformWrappers;
    }

    getTransformById(designWrapper: DesignWrapper, transform_Id: number) {
        for (let i = 0; i < designWrapper.design.objects.length; i++) {
            let transform = designWrapper.design.objects[i];
            let obj_Id = this.getTransform_Id(transform);
            if (transform_Id != obj_Id) continue;
            return transform;
        }
    }

    dataObjectChanged(dataObjectWrapper: DataObjectWrapper, objectWrapper: SourceWrapper) {
        objectWrapper.source.src_Inst.dObj_Id = dataObjectWrapper.obj_Id;
        objectWrapper.source.dataObject = dataObjectWrapper.dataObject;
        objectWrapper.imageUrl = dataObjectWrapper.imageUrl;

        if (objectWrapper.source.attributes.length > 0) {
            objectWrapper.source.attributes.splice(0, objectWrapper.source.attributes.length);

            for (let i = 0; i < dataObjectWrapper.dataObject.attributes.length; i++) {
                let attributeDO: Attribute = dataObjectWrapper.dataObject.attributes[i];
                let attributeNew: Attribute = new Attribute();

                attributeNew.attr_Id = this.objectWrapperUtil.getNewSub_Id(objectWrapper);
                attributeNew.attrNm = this.util.getNewName(attributeDO.attrNm, objectWrapper.subNames);

                attributeNew.obj_Id = objectWrapper.obj_Id;

                attributeNew.attrDTyp_Id = attributeDO.attrDTyp_Id;
                attributeNew.attrPrec = attributeDO.attrPrec;
                attributeNew.attrScale = attributeDO.attrScale;

                attributeNew.lnk_Obj_Id = dataObjectWrapper.dataObject.dObj.dObj_Id;
                attributeNew.lnk_Attr_Id = attributeDO.attr_Id;

                attributeNew.srt_Order = objectWrapper.source.attributes.length;

                objectWrapper.source.attributes.push(attributeNew);
            }
        } else {
            for (let i = 0; i < objectWrapper.source.attributes.length; i++) {
                objectWrapper.source.attributes[i].lnk_Obj_Id = -1;
                objectWrapper.source.attributes[i].lnk_Attr_Id = -1;
            }
        }
    }


}